export { default } from './ClassificationMarking';
export type { ClassificationMarkingProps } from './ClassificationMarking.types';
